const TEXTAREA_MAX_LENGTH = 4000;
const TEXTAREA_MIN_LENGTH = 1;

const REASON_FOR_CANCEL_OPTIONS = [
    {
        value: 'AI',
        text: 'member.enrollment.modal.premiumHistoryModal.noReason',
    },
    {
        value: '59',
        text: 'member.enrollment.modal.premiumHistoryModal.nonPayment',
    },
    {
        value: '14',
        text: 'member.enrollment.modal.premiumHistoryModal.voluntary',
    },
];

const NO_PAYMENT_VALUE = REASON_FOR_CANCEL_OPTIONS[1].value; //retuening 59 value

const REINSTATEMENT_STATUS = {
    CANNOT_REINSTATED: 'CANNOT_REINSTATED',
    SUBSEQUENT_APP_SUBMITTED: 'SUBSEQUENT_APP_SUBMITTED',
};

export { NO_PAYMENT_VALUE, REASON_FOR_CANCEL_OPTIONS, REINSTATEMENT_STATUS, TEXTAREA_MAX_LENGTH, TEXTAREA_MIN_LENGTH };
